import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes,Navigate } from 'react-router-dom';
import './App.css';
import Home from './Home/Home';
import Contact from './Contact/Contact';
import Header from './Home/HeaderComponent/Header';
import Navbars from './Home/HeaderComponent/NavbarsComponent/Navbars';
import AOS from 'aos';
import 'aos/dist/aos.css';
import IQAC from './IQAC/Iqac';
import Report from './IQAC/Report';
import Affiliation from './About US/Affiliation';
import Vision_Mission from './About US/Vision_Mission';
import Infrastructure from './About US/infrastructure/Infrastructure';
import Overview from './About US/overview/Overview';
// import Overview2 from './About US/overview/Overview2';
import Message from './About US/Message/Message';
import Gallery from './About US/Gallery/Gallery';
import Course from './Academics/Course/Course';
import Admission from './Academics/Admission';
// import AppliedScience from './Department/AppliedScience/AppliedScience';
import Computerlab from './Department/ComputerLab/Computerlab.jsx';
// import Architect from './Department/Architect/Architect';
import Civil from './Department/Civil/Civil.jsx';
import Computer from './Department/ComputerScience/Computer.jsx';
import Electrical from './Department/Electrical/Electrical.jsx';
import Mechanical from './Department/Mechanical/Mechanical.jsx';
import EnquiryForm from '../src/Apply/EnquiryForm.jsx'; 
import Electronic from './Department/Electronic/Electronic.jsx';
import Latest_information from './Latest/Latest_information.jsx';
import All from './Authentication/Inform/All.jsx';
import NoticeUploadForm from './Authentication/NoticeUploadForm.jsx';
import Download from './Academics/Download/Download.jsx';
import Notice from './IQAC/Notice/Notice.jsx';
import NEWS from './News/News.jsx';
import Placement from './Placement/Placement.jsx';
import Naac from './IQAC/naac/Naac.jsx';
import Naac_2 from './IQAC/naac2a/Naac_2.jsx';
import Naac_2b from './IQAC/naac2b/Naac_2b.jsx';
import Placementlist from './Placement/placementlist/Placementlist.jsx';
import AdmissionForm from "./component/AdmissionForm";
import AdminLogin from "./component/AdminLogin";
import AdminPanel from "./component/AdminPanel";
import Step from "./component/Step";
import Account from "./component/Account";
import Notices from "./notice/Notices.jsx"
import Syllabus from "./Academics/Syllabus/Syllabus.jsx"




AOS.init({
  offset: 120, 
  delay: 0, 
  duration: 1000, 
  easing: 'ease', 
  once: false, 
  mirror: false, 
  anchorPlacement: 'top-bottom',
  loop: true,
});

function App() {
  
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);

  useEffect(() => {
    
    const timer = setTimeout(() => {
      setShowEnquiryForm(true);
    }, 10000);

    return () => clearTimeout(timer); 
  }, []);

  
  const closeModal = () => {
    setShowEnquiryForm(false); 
  };
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem("token"));

  return (
    <Router>
      <Header />
      <Navbars />
      <Routes>
        {/* Define routes for Home, About, and Contact */}
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Iqac" element={<IQAC />} />
        <Route path="/Report" element={<Report />} />
        <Route path="/Affiliation" element={<Affiliation />} />
        <Route path="/Vision_Mission" element={<Vision_Mission />} />
        <Route path="/Infrastructure" element={<Infrastructure />} />
        <Route path="/Overview" element={<Overview />} />
        <Route path="/Message" element={<Message />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route path="/Course" element={<Course />} />
        <Route path="/Admission" element={<Admission />} />
        <Route path="/Civil" element={<Civil />} />
        <Route path="/Computer" element={<Computer />} />
        <Route path="/Electrical" element={<Electrical />} />
        <Route path="/Mechanical" element={<Mechanical />} />
        <Route path="/Electronic" element={<Electronic />} />
        <Route path="/Computerlab" element={<Computerlab />} />
         <Route path="/All" element={<All/>} />
         <Route path="/Latest_information" element={<Latest_information/>} /> 
         <Route path="/NoticeUploadForm" element={<NoticeUploadForm/>} /> 
         <Route path="/Download" element={<Download/>} /> 
         <Route path="/NEWS" element={<NEWS/>} /> 
         <Route path="/Placement" element={<Placement/>} />  
         <Route path="/Notice" element={<Notice/>} />            
         <Route path="/Naac" element={<Naac/>} />  
         <Route path="/Naac_2" element={<Naac_2/>} />  
         <Route path="/Naac_2b" element={<Naac_2b/>} />  
         <Route path="/Placementlist" element={<Placementlist/>} />  
         <Route path="/Step" element={<Step />} />
        <Route path="/AdmissionForm" element={<AdmissionForm />} />
        <Route path="/Account" element={<Account />} />
        <Route path="/AdminPanel" element={<AdminPanel />} />
        <Route path="/Notices" element={<Notices />} />
        <Route path="/Syllabus" element={<Syllabus />} />

        <Route
          path="/AdminLogin"
          element={<AdminLogin onLogin={() => setLoggedIn(true)} />}
        />

        <Route
          path="/AdminPanel"
          element={loggedIn ? <AdminPanel /> : <Navigate to="/AdminLogin" />}
        />
      
        

      </Routes>
      {showEnquiryForm && <EnquiryForm closeModal={closeModal} />}
    </Router>
  );
}

export default App;
